import styled from 'styled-components';
import { PageFullWidth, theme } from 'Ui';
import icoReturn from 'Assets/images/icoReturn.svg';
import icoBrands from 'Assets/images/icoBrands.svg';
import icoPayment from 'Assets/images/icoPayment.svg';
import icoSupport from 'Assets/images/icoSupport.svg';

const ReassurancesContainer = styled.div`
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  margin: 0 auto;
  padding: 4rem 0;
  gap: 4rem;

  @media screen and (max-width: 768px) {
    padding: 3.2rem 2.4rem;
    row-gap: 3.2rem;
  }
`;

const Item = styled.div`
  width: 16rem;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 1.6rem;

  @media screen and (max-width: 768px) {
    width: 15.5rem;
  }
`;

const Icon = styled.img`
  display: block;
  height: 1.8rem;
  width: auto;
`;

const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.span`
  font-family: var(--font-primary);
  font-weight: 600;
  font-size: 1.1rem;
  line-height: normal;
  color: #000;
`;

const Subtitle = styled.span`
  font-family: var(--font-primary);
  font-weight: 400;
  font-size: 1.2rem;
  line-height: 1.8rem;
  color: ${theme.light.colors.grayUltraDark};
`;

type Props = {
  returns: string;
  returnsText: string;
  brand: string;
  brandText: string;
  payment: string;
  paymentText: string;
  support: string;
  supportText: string;
};

export const Reassurances = ({
  returns,
  returnsText,
  brand,
  brandText,
  payment,
  paymentText,
  support,
  supportText,
}: Props) => {
  const items = [
    { icon: icoReturn, title: returns, subtitle: returnsText },
    { icon: icoBrands, title: brand, subtitle: brandText },
    { icon: icoPayment, title: payment, subtitle: paymentText },
    { icon: icoSupport, title: support, subtitle: supportText },
  ];

  return (
    <PageFullWidth>
      <ReassurancesContainer>
        {items.map((item) => (
          <Item key={item.title}>
            <Icon src={item.icon} alt="" aria-hidden="true" />
            <TextBlock>
              <Title>{item.title}</Title>
              <Subtitle>{item.subtitle}</Subtitle>
            </TextBlock>
          </Item>
        ))}
      </ReassurancesContainer>
    </PageFullWidth>
  );
};

export default Reassurances;
